import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { clientStorage } from "./dummyEngine";

export type LanguageStore = {
  language?: string;
  setLanguage: (language?: string) => void;
};

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set) => ({
      language:
        ["en", "da", "tr"].find(
          (lan) => lan === navigator.language?.split("-")?.[0],
        ) ?? "en",
      setLanguage: (language) => set({ language }),
    }),
    {
      name: "language-store",
      storage: createJSONStorage(() => clientStorage),
    },
  ),
);
